<div class="mymain py-4">
  <header class="d-flex flex-column align-items-center gap-1">
    <div class="fs-xxl align-self-start mb-4">Compra #<strong>{{purchaseCode}}</strong></div>
    <div class="fs-lg"><strong>¡Tu compra ha sido exitosa!</strong></div>
    <div class="fs-lg">Te avisaremos cuando tus productos esten en camino.</div>
  </header>
  <div>
    <ng-container *ngIf="currentCart?.length > 0 && !isPendingPayment;else isPendingPaymentTemplate">
      <div class="products-container">
        <!-- Product / Service -->
        <div class="product card pb-5 border-0 w-100 position-relative" *ngFor="let itemCart of currentCart; index as i">
          <div class="row h-100 align-items-center">
            <div class="col-md-3 d-flex" style="height: 140px !important;">
              <img class="img-fluid rounded" [src]="getItemImage(itemCart.item.images)" alt="itemCart.item.name">
            </div>

            <div class="col-md-9 h-100">
              <div class="card-body h-100 row gy-4">
                <div class="col-12 col-md-5">
                  <p class="card-title fs-md"><strong>{{itemCart.item.name}}</strong></p>
                  <div *ngIf="isProduct(itemCart.item)">
                    <p class="text-muted">Servicios Adicionales:</p>
                    <p [hidden]="!itemCart.item.additionalServices?.addDentalMonitoring">Dental Monitoring <u>+{{itemCart.item.itemPrices.priceExtraDentalMonitoring}}</u></p>
                    <p [hidden]="!itemCart.item.additionalServices?.addIsComplexCase">Caso Complejo <u>+{{itemCart.item.itemPrices.priceComplexCase}}</u></p>
                    <p>
                      <ng-container *ngIf="itemCart.item.hasUnlimitedAligners; else hasNotUnlimitedAligners">
                        <span>¡Este producto tiene alineadores ilimitados!</span>
                      </ng-container>
                      <ng-template #hasNotUnlimitedAligners>
                        <span [hidden]="itemCart.item.additionalServices?.extraAlignersQuantity == 0">{{itemCart.item.additionalServices.extraAlignersQuantity}} Alineadores Extra <u>+{{itemCart.item.additionalServices.extraAlignersQuantity * itemCart.item.itemPrices.priceExtraAligner}}</u></span>
                      </ng-template>
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="d-flex"><p class="w-100 mt-md-auto text-end text-md-start" [ngClass]="{'text-decoration-line-through': itemCart.item.itemPrices.shoppingDiscount != null}">{{itemCart.item.itemPrices.price | currency}}</p> <span class="badge badge-price ms-2 my-auto" [ngClass]="{'text-decoration-line-through': itemCart.item.itemPrices.shoppingDiscount != null}">Precio regular</span></div>
                  <div class="d-flex" *ngIf="itemCart.item.itemPrices.shoppingDiscount && itemCart.item.itemPrices.shoppingDiscount != 0 "><p class="w-100 text-end text-md-start" >{{itemCart.item?.itemPrices.priceWithDiscount | currency}}</p> <span class="badge badge-price ms-2 my-auto">Precio con descuento</span></div>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="position-absolute w-75 start-50 translate-middle"></mat-divider>
        </div>
      </div>
      <div class="d-flex mb-2">
        <div class="ms-auto" *ngIf="percentageForMSIUsage>0; else JustTotal">
          <p>Subtotal: {{subtotal.toFixed(2) | currency}}</p>
          <p>Comisión bancaria por financiamiento: {{percentageForMSIUsage.toFixed(2) | currency}}</p>
          <p class="fw-semibold">Total: {{ getTotalWOOrder() | currency}}</p>
        </div>
        <ng-template #JustTotal>
          <p class="fw-semibold">Total: {{ subtotal.toFixed(2) | currency}}</p>
        </ng-template>
        
      </div>
    </ng-container>
    <ng-template #isPendingPaymentTemplate>
      <div class="products-container">
        <!-- Product / Service -->
        <div class="product card pb-5 border-0 w-100 position-relative">
          <div class="row gy-3 h-100 align-items-center">
            <div class="col-md-3 d-flex" style="height: 140px !important;">
              <img class="img-fluid rounded" [src]="getItemImage(this.currentOrder?.orderDetail[0]?.product.productImages)">
            </div>

            <div class="col-md-9 h-100">
              <div class="card-body h-100 row gy-4">
                <div class="col-12 col-md-5">
                  <p class="card-title fs-md"><strong>{{this.currentOrder?.orderDetail[0]?.productName}}</strong></p>
                  <div>
                    <p class="text-muted">Servicios Adicionales:</p>
                    <p [hidden]="!currentOrder.orderDetail[0].addedDentalMonitoring">Dental Monitoring <u>+{{currentOrder?.orderDetail[0]?.dentalMonitoringPrice}}</u></p>
                    <p [hidden]="!currentOrder.orderDetail[0].addedIsComplexCase">Caso Complejo <u>+{{currentOrder?.orderDetail[0]?.priceComplexCase}}</u></p>
                    <p>
                      <ng-container *ngIf="this.currentProduct.hasUnlimitedAligners; else hasNotUnlimitedAligners">
                        <span>¡Este producto tiene alineadores ilimitados!</span>
                      </ng-container>
                      <ng-template #hasNotUnlimitedAligners>
                        <span [hidden]="currentOrder.orderDetail[0].productExtraAlignersQuantity == 0">{{currentOrder?.orderDetail[0]?.productExtraAlignersQuantity}} Alineadores Extra <u>+{{currentOrder.orderDetail[0].productExtraAlignersQuantity * currentOrder.orderDetail[0].productExtraAlignersPrice}}</u></span>
                      </ng-template>
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="d-flex"><p class="w-100 mt-md-auto text-end text-md-start" >{{this.currentOrder?.orderDetail[0]?.productPrice | currency}}</p><span class="badge badge-price ms-2 my-auto">Precio regular</span></div>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="position-absolute w-75 start-50 translate-middle"></mat-divider>
        </div>
      </div>
      <div class="d-flex mb-2">
        <div class="ms-auto" *ngIf="currentOrder.percentageAmountForMSIUsage >0; else JustTotalO">
          <p>Subtotal: {{currentOrder.total.toFixed(2) | currency}}</p>
          <p>Comisión bancaria por financiamiento: {{currentOrder.percentageAmountForMSIUsage.toFixed(2) | currency}}</p>
          <p class="fw-semibold">Total: {{getTotalWithOrder() | currency}}</p>
        </div>
        <ng-template #JustTotalO>
          <div class="ms-auto">
            <p class="fw-semibold">Total: {{currentOrder.total.toFixed(2) | currency}}</p>
          </div>
        </ng-template>
      </div>
    </ng-template>
   
  </div>


  <div class="my-0 mx-auto">
      <button mat-button class="mybtn" (click)="goToEcommerceTienda()">Seguir comprando <mat-icon>store</mat-icon></button>
      <button mat-button class="mybtn" (click)="goToMisCompras()">Ir a mis compras <mat-icon>shopping_bag</mat-icon></button>
  </div>
</div>
